import React, { useContext } from "react";
import { Link, useLocation } from 'react-router-dom';
import { AppContext } from "../App";
import { getImageUrl } from "../pages/homepageUtils";

export default function CollectionBox({ d }) {
  const strapiURL = useContext(AppContext)
  const location = useLocation();

  if (!d) {
    return null;
  }

  const imageUrl = getImageUrl(d, strapiURL);
  const itemUrl = `/collection/${d.documentId}${location.search}`;

  return (
    <Link to={itemUrl} className="retro-catalog-card" state={{ from: `${location.pathname}${location.search}` }}>
      <div className="retro-catalog-card-image">
        {imageUrl ? (
          <img loading="lazy" decoding="async" src={imageUrl} alt={d.Name} />
        ) : (
          <span>Brak zdjęcia</span>
        )}
      </div>
      <div className="retro-catalog-card-body">
        <h3>{d.Name}</h3>
        <div className="retro-catalog-card-meta">
          <span>{d.kind?.Name || '-'}</span>
          <span>{d.manufacturer?.Name || 'Producent nieznany'}</span>
          {d.RokProdukcji && <span>{d.RokProdukcji}</span>}
        </div>
      </div>
    </Link>
  );
}
